import HolidaysContainer from "~/Holidays/HolidaysContainer"

export default HolidaysContainer
